import { FC, useEffect, useRef } from "react";
import LeaderLine from "leader-line-new";

interface ArrowProps {
    startElementId: string;
    endElementId: string;
    isReplaced: boolean;
}

const Arrow: FC<ArrowProps> = ({ startElementId, endElementId, isReplaced }) => {
    const arrowRef = useRef<LeaderLine | null>(null);

    useEffect(() => {
        const startElement = document.getElementById(startElementId);
        const endElement = document.getElementById(endElementId);
        if (startElement && endElement) {
            arrowRef.current = new LeaderLine(
                startElement,
                endElement,
                isReplaced ? { color: "red", dash: true } : { color: "#21ba45" },
            );
            arrowRef.current.setOptions({ startSocket: "right", endSocket: "auto" });
        }
        return () => {
            if (arrowRef.current) {
                arrowRef.current.remove();
            }
        };
    }, [startElementId, endElementId, isReplaced]);

    useEffect(() => {
        if (arrowRef.current) {
            arrowRef.current.position();
        }
    });

    return null;
};

export default Arrow;
